import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useTheme } from "units/dashboard/context/ThemeProvider";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation("landing");
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={t("a11y.toggleTheme")}
      aria-pressed={isDark}
      className={clsx(
        "relative h-[30px] w-14 shrink-0 rounded-full border-[1.5px] border-line bg-surface-2",
        "transition-colors duration-300 hover:border-teal-2",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-2 focus-visible:ring-offset-2"
      )}
    >
      <span
        className={clsx(
          "absolute top-[2px] start-[2px] grid h-[22px] w-[22px] place-items-center rounded-full text-[11px] leading-none shadow-[0_3px_8px_rgba(0,0,0,0.15)]",
          "transition-transform duration-500 ease-snap",
          isDark
            ? "bg-gradient-to-br from-teal to-teal-2 rtl:-translate-x-[26px] ltr:translate-x-[26px]"
            : "bg-gradient-to-br from-gold to-gold-2 translate-x-0"
        )}
      >
        {isDark ? "☾" : "☀"}
      </span>
    </button>
  );
};

export default ThemeToggle;